export default __webpack_public_path__ + "static/media/dev02.e6db9513.jpg";